'use strict';

// ozira-contracts — canonical, versioned, runtime-validated contracts shared
// across every OZIRA product experience and the OZIRA AI Operating Platform.
//
// This package contains ONLY pure validation functions and enumerations. No
// infrastructure, no database client, no network calls, no provider SDK, no
// secrets. See docs/architecture.md for the full contract catalog, trust
// rules, and versioning strategy.

const { ContractError, contractError } = require('./validation');
const enums = require('./enums');
const { validatePrincipal } = require('./principal');
const { validateEventEnvelope } = require('./event');
const { validateActionRequest, validateActionResult, validateAuthorityDecision } = require('./action');
const { validateApprovalRequest } = require('./approval');
const { validateToolInvocation, validateToolResult } = require('./tool');
const { validateConnectorExecution } = require('./connector');
const { validateAuditEvent } = require('./audit');
const { validateNotification } = require('./notification');
const { validatePAgentIntent, validatePAgentResponse } = require('./p2p');
const {
  validateHQSignal, validateHQMetric, validateHQRisk, validateHQOpportunity,
  validateHQRecommendation, validateHQDecisionRequest, validateHQDepartmentSnapshot, validateHQBrief,
} = require('./hq');

module.exports = {
  ContractError,
  contractError,
  ...enums,
  validatePrincipal,
  validateEventEnvelope,
  validateActionRequest,
  validateActionResult,
  validateAuthorityDecision,
  validateApprovalRequest,
  validateToolInvocation,
  validateToolResult,
  validateConnectorExecution,
  validateAuditEvent,
  validateNotification,
  validatePAgentIntent,
  validatePAgentResponse,
  validateHQSignal,
  validateHQMetric,
  validateHQRisk,
  validateHQOpportunity,
  validateHQRecommendation,
  validateHQDecisionRequest,
  validateHQDepartmentSnapshot,
  validateHQBrief,
};
